import { Routes } from '@angular/router';
import { SearchGameComponent } from '../../components/games/search-game/search-game.component';

export const SEARCH_MODULE_NOT_TRANSLATED: Routes = [
  {
    path: '',
    component: SearchGameComponent,
    children: []
  },
  {
    path: ':term',
    component: SearchGameComponent,
    children: []
  }
];
